export default "__VITE_ASSET__f3ce9c5b__"